import React, { Component } from 'react';
import PhotoCardsSwiper from "../components/PhotoCardsSwiper";
import { Link } from "react-router-dom";

const cardImages = [
  "images/Blog/cardconsejoenero1.jpg",
  "images/Blog/cardconsejoenero2.jpg",
  "images/Blog/cardconsejoenero3.jpg",
  "images/Blog/cardconsejoenero4.jpg",
  "images/Blog/cardconsejoenero5.jpg"
];

class ConsejoEnero extends Component {
  componentDidMount() {
  if (window.startx) {
    window.startx();
  }
}
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>¡Cuerpo y mente tu súper máquina: Descubre tu cuerpo</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/portadaconsejoenero.jpg" alt="Dinosaurios Animatrónicos" />
          </div>
          <span className="containerblog">
            <div className="align justify">
              <p>
                Durante el Taller de Viernes de Consejo del mes de enero, las niñas y los niños vivieron una jornada llena de aprendizaje, 
                diversión y descubrimientos al explorar el tema: <b>“Cuerpo y mente, tu súper máquina: descubre tu cuerpo”</b>.
                A lo largo de la sesión, participaron en diversas actividades diseñadas para despertar su curiosidad y fomentar el aprendizaje
                a través del juego. Mediante dinámicas interactivas, materiales didácticos y ejercicios prácticos, conocieron las principales
                partes del cuerpo, el funcionamiento de algunos órganos y la importancia de mantener hábitos saludables.
              </p>
              <p>
               Las y los participantes descubrieron que el cuerpo y la mente trabajan juntos como una verdadera súper máquina, donde cada sistema
              cumple una función esencial para permitirnos pensar, movernos, sentir y aprender. El taller promovió la participación activa, el
               trabajo en equipo y la expresión de ideas, permitiendo que cada niña y niño compartiera sus conocimientos, preguntas y experiencias. 
               Entre risas, juegos y mucha creatividad, la ciencia se convirtió en una experiencia cercana y emocionante.
              </p>
              <p>
                Este tipo de actividades forman parte del compromiso del museo por ofrecer espacios educativos y recreativos que acerquen la 
                ciencia y el conocimiento a la niñez de una manera accesible, dinámica y significativa. Te invitamos a formar parte de esta 
                experiencia en el <b>Taller de Viernes de Consejo</b>, que se realiza el <b>último viernes de cada mes</b>, donde siempre 
                habrá un tema nuevo por descubrir, aprender y disfrutar.
              </p>
              <p>
                <strong>¡Te esperamos en futuros Talleres de Consejo Tecnico!</strong>
              </p>
              
            </div>
             {/* GALERÍA REUTILIZABLE */}
            <div className="container">

              <h3 className='section-title'>Momentos Destacados</h3>
              <PhotoCardsSwiper images={cardImages} />
            </div>
            <div>
              <div className="containerjuego">
                <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default ConsejoEnero;